var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.372.025A8 8 0 1 1 .005 7.739a.75.75 0 0 1 1.5.044 6.5 6.5 0 1 0 1.573-4.03l-.204.25h1.877l.102.007a.75.75 0 0 1 0 1.487l-.102.006H1.253l-.102-.006a.75.75 0 0 1-.641-.642l-.007-.102v-4L.51.652A.75.75 0 0 1 1.151.01l.102-.006.102.006a.75.75 0 0 1 .641.642l.007.1-.001 1.954A7.98 7.98 0 0 1 7.372.025m.378 3.978.102.007a.75.75 0 0 1 .641.642l.007.1V8h1.75l.102.008a.75.75 0 0 1 0 1.486l-.102.007h-2.5l-.102-.007a.75.75 0 0 1-.641-.641L7 8.75V4.753l.007-.101a.75.75 0 0 1 .641-.642z"
  })));
};
export default SvgHistory;